import { Component, OnInit, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Api } from "../../common/api";
import { Constants } from "../../common/constants";
import { IProperty } from "../../common/property";
import { MainService } from "../../services/main.service";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.scss"],
})
export class UserComponent implements OnInit {
  value: any;
  categoryData: any;
  pageChangedNumber: number;
  itemsPerPageValue: number;
  public parameter: IProperty = {};
  modelCustomize: any;
  model: any;
  modalRef: BsModalRef;
  deleteId: any;
  deleteItem: any;
  config: any;
  search = "";
  searchTimer: any;
  copyTimer: any;
  pageSizes = [10, 25, 50, 100];

  constructor(
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private mainService: MainService,
    private api: Api,
    public constants: Constants,
    private router: Router
  ) {
    this.parameter.page = 1;
    this.parameter.itemsPerPage = this.constants.itemsPerPage;
    this.config = {
      backdrop: true,
      ignoreBackdropClick: true,
      animated: true,
      keyboard: false,
    };
  }

  getPage(page) {
    this.parameter.page = page;
    this.getUsers();
  }

  pageChanged(event: any): void {
    this.pageChangedNumber = event.page;
    this.itemsPerPageValue = event.itemsPerPage;
    //console.log('Page changed to: ' + event.page);
    //console.log('Number items per page: ' + event.itemsPerPage);
  }

  editItem(categories_id: string) {
    this.router.navigate(["/edit-user", categories_id]);
  }

  ngOnInit(): void {
    this.getUsers();
  }

  getUsers() {
    const offset = this.parameter.page - 1;
    const input: any = {
      limit: this.parameter.itemsPerPage,
      skip: offset,
    };
    if (this.search && this.search.trim()) {
      input.search = this.search.trim();
    }
    this.mainService
      .getDataAptWithParams(this.api.paths.getUsers, input)
      .subscribe((success) => {
        this.modelCustomize = success["data"];
        this.parameter.total = success["total"];
        //console.log("this.parameter.total",this.parameter.total)
      });
  }

  // Debounce the keystrokes so we only hit the API once the user pauses
  searchChanged() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.parameter.page = 1;
      this.getUsers();
    }, 500);
  }

  clearSearch() {
    this.search = "";
    this.parameter.page = 1;
    this.getUsers();
  }

  changePageSize(size) {
    this.parameter.itemsPerPage = Number(size);
    this.parameter.page = 1;
    this.getUsers();
  }

  changeStatus(userId, status) {
    const input = {
      userId: userId,
      isActive: status,
    };
    this.mainService
      .postDataApi(this.api.paths.editUser, input)
      .subscribe((success) => {
        this.toastrService.success(success["message"]);
        this.getUsers();
      });
  }

  opendeletemodal(item, template: TemplateRef<any>) {
    this.deleteId = item._id;
    this.deleteItem = item;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "gray modal-md" }, this.config)
    );
  }

  delete(delId) {
    //console.log("Deleted Item Called", delId)

    this.mainService
      .deleteDataApi(this.api.paths.deleteUser + "?userId=" + delId, {})
      .subscribe(
        (success) => {
          this.modalRef.hide();
          this.toastrService.success("User deleted successfully");
          // Step back a page when the last record of the current page is gone
          if (this.modelCustomize?.length == 1 && this.parameter.page > 1) {
            this.parameter.page = this.parameter.page - 1;
          }
          this.getUsers();
        },
        () => {
          // The interceptor already surfaces the error message
          this.modalRef.hide();
        }
      );
  }

  // Single click copies the link, double click opens it. The copy is delayed a
  // little so a double click can cancel it instead of firing twice.
  onCopyClick(val: string) {
    clearTimeout(this.copyTimer);
    this.copyTimer = setTimeout(() => {
      this.copyMessage(val);
      this.toastrService.success("Link copied");
    }, 250);
  }

  openLink(val: string) {
    clearTimeout(this.copyTimer);
    window.open(this.userLink(val), "_blank");
  }

  userLink(val: string) {
    return "https://euro.immivisas.in/user/" + val;
  }

  copyMessage(val: string) {
    const newVal = this.userLink(val);
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = newVal;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }
}
